import '../src/js/email-suggestion';
import validateEmail from '../src/js/email-validation';
validateEmail();
